import React, { useCallback } from 'react';
import { useDateURLFormatter } from '../../../../../data/hooks/datetimeHooks';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { handleAPIProvidedErrorMessage } from '../../../../../misc/handleAPIProvidedErrorMessage';
import ButtonLink from '../../../../elements/ButtonLink';
import { dialogAlert } from '../../../../elements/Dialog/dialogs';
import styles from './CreateMeetingButton.module.scss';

const CreateMeetingButton = (props) => {
    const { event, rescheduleMeeting, slot, motiv, location, participants, speakers } = props,
        i18n = useI18n(),
        disabled = participants.length + speakers.length == 0,
        formatDate = useDateURLFormatter();

    const handleCreateMeeting = useCallback(async () => {
        if (slot && location) {
            if ((!slot.program_id || slot.note_required) && !motiv) {
                await dialogAlert(i18n['error.meeting-note-description-required']);
            } else {
                app.store.dispatch(app.actions.ui.busy());
                app.api.meetings
                    .invite(event.id, location.id, slot.start, 'Meeting', participants, speakers, motiv || undefined, {
                        rescheduleMeetingId: rescheduleMeeting?.id,
                    })
                    .then(async (meeting) => {
                        await dialogAlert(i18n['msg.request.sent']);
                        app.history.push(['/events', event.id, 'meetings', 'sent'].join('/') + `?meeting=${meeting.id}`);
                        return meeting;
                    })
                    .catch(handleAPIProvidedErrorMessage)
                    .then((meeting) => {
                        app.store.dispatch(app.actions.ui.free());
                        return meeting;
                    });
            }
        }
    }, [slot, location, motiv, participants, speakers]);

    return (
        <ButtonLink className={styles.CreateMeetingButton} disabled={disabled} onClick={handleCreateMeeting}>
            {i18n['label.confirm']}
        </ButtonLink>
    );
};

export default CreateMeetingButton;
